/**
 * HR, attendance, payroll (docs/BUILD-PHASES.md Phase 13).
 */
import { z } from 'zod';
import { idSchema, paisaSchema } from './common.js';
import { ATTENDANCE_STATUSES } from '../constants.js';
export const EMPLOYEE_STATUSES = ['ACTIVE', 'ON_LEAVE', 'SUSPENDED', 'RESIGNED', 'TERMINATED'];
export const allowanceSchema = z.object({ name: z.string().min(1).max(60), amountPaisa: paisaSchema });
export const upsertEmployeeSchema = z.object({
    shopId: idSchema.nullable().optional(),
    employeeCode: z.string().min(1).max(30),
    fullName: z.string().min(1).max(120),
    fatherName: z.string().max(120).optional(),
    cnic: z.string().max(20).optional(),
    phone: z.string().max(20).optional(),
    designation: z.string().max(80).optional(),
    department: z.string().max(80).optional(),
    joiningDate: z.coerce.date().optional(),
    status: z.enum(EMPLOYEE_STATUSES).default('ACTIVE'),
    basicPaisa: paisaSchema.min(0).default(0),
    allowances: z.array(allowanceSchema).default([]),
    bankName: z.string().max(80).optional(),
    bankAccountNo: z.string().max(40).optional(),
});
export const listEmployeesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    shopId: idSchema.optional(),
    status: z.string().optional(),
});
export const markAttendanceSchema = z.object({
    employeeId: idSchema,
    businessDate: z.coerce.date(),
    status: z.enum(ATTENDANCE_STATUSES),
    checkInAt: z.coerce.date().optional(),
    checkOutAt: z.coerce.date().optional(),
    note: z.string().max(300).optional(),
});
export const bulkAttendanceSchema = z.object({
    businessDate: z.coerce.date(),
    entries: z.array(z.object({ employeeId: idSchema, status: z.enum(ATTENDANCE_STATUSES) })).min(1),
});
export const createAdvanceSchema = z.object({
    employeeId: idSchema,
    amountPaisa: paisaSchema.min(1),
    installments: z.number().int().min(1).default(1),
    reason: z.string().max(300).optional(),
    isLoan: z.boolean().default(false),
});
export const createPayrollRunSchema = z.object({
    shopId: idSchema.optional(),
    year: z.number().int().min(2000).max(2100),
    month: z.number().int().min(1).max(12),
});
/* -------------------------------------------------------------------------- */
/* Leave (docs/BUILD-PHASES.md Phase 8 — added 2026-08-10)                    */
/* -------------------------------------------------------------------------- */
export const upsertLeaveTypeSchema = z.object({
    name: z.string().min(1).max(60),
    annualQuota: z.number().int().min(0).default(0),
    isPaid: z.boolean().default(true),
    isActive: z.boolean().default(true),
});
export const createLeaveRequestSchema = z
    .object({
    employeeId: idSchema,
    leaveTypeId: idSchema,
    fromDate: z.coerce.date(),
    toDate: z.coerce.date(),
    reason: z.string().max(500).optional(),
})
    .refine((v) => v.toDate >= v.fromDate, { message: 'toDate must be on or after fromDate', path: ['toDate'] });
export const decideLeaveRequestSchema = z.object({
    note: z.string().max(300).optional(),
});
export const listLeaveRequestsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    employeeId: idSchema.optional(),
    status: z.enum(['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED']).optional(),
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
//# sourceMappingURL=hr.js.map